import React, { Component } from 'react';

import ProjectContent from '../../../components/ProjectContent';
import Objectifs from '../../../components/Objectifs';
import '../../../css/views/project.css';
import cic1 from '../../../images/cic1.jpg'
import cic2 from '../../../images/cic2.jpg'
import cic3 from '../../../images/cic3.jpg'

export default class CiCSeriousGame extends Component {
	render() {
		const { img, objectives } = this.props;

		return (
			<div className="cic-project">
				<ProjectContent enjeux>
					<p className="text-detail">
						Le CIC - SUD OUEST est soucieux de former ses collaborateurs afin de
						s’adapter toujours mieux aux besoins des clients. Pour cette
						édition, le CIC souhaitait sensibiliser de manière ludique l’offre
						d’Epargne Financière afin qu’ils soient en phase avec les attentes
						du marché. Ce serious game en ligne devait donc porter tous ces aspects, mais
						aussi s’inscrire dans les codes du jeu tout en prenant en compte les{' '}
						<strong>enjeux métiers liés à l’univers de la banque</strong>.
					</p>
				</ProjectContent>

				<Objectifs src={img} objectives={objectives} />

				<ProjectContent
					mecanique
					subtitle="Un outil de formation sous la forme d'un jeu en ligne pour de meilleures performances"
				>
					<p className="text-detail">
						Chaque semaine, une nouvelle manche abordant un nouveau type de
						profil client était mise en ligne. Des questions en liens avec
						celui-ci étaient posées aux équipes. Les points cumulés au cours de
						la partie <strong>« Questions-Réponses »</strong> étaient convertis
						en capital afin d'investir dans un{' '}
						<strong>jeu de simulation boursière.</strong>
					</p>
					<p className="text-detail">
						Les équipes pouvaient investir leur « argent » dans différents
						véhicules d'investissement et revendre leurs actions en fonction de
						leurs prévisions sur l'influence des cours.
					</p>
					<p className="text-detail">
						La mécanique du jeu comprenant également{' '}
						<strong>
							un système d'actualités et d'évolutions de tendances
						</strong>{' '}
						qui permettait d'influer positivement ou négativement sur les cours.
					</p>
					<p className="text-detail">
						Deux classements, un pour la rubrique « Questions-Réponses »,
						l'autre pour la rubrique « Jeu de simulation boursière » étaient
						consultables par tous dans le but de challenger les équipes.
					</p>
					<p className="text-detail">
						Le CIC avait accès à tout moment{' '}
						<strong>aux statistiques de participation</strong>.
					</p>
					<section>
					<picture className={"small-img gradient-rose-bleu"}>
						<img src={cic1} alt=""/>
					</picture>
					</section>
				</ProjectContent>

				<ProjectContent altTitle="Identité graphique et ergonomie">
					<p className="text-detail">
						En partenariat avec un illustrateur chargé de dessiner les
						différents types de profil client,{' '}
						<strong>
							ARCA a mis en place un univers graphique en rapport avec l'unviers
							de la bourse.
						</strong>
						<br />
						L'outil se devait d'être pédagogique et ludique, et être assimilé
						avant tout comme un jeu (« serious game »). Nous avons donc réaliser
						notre webdesign et l'ambiance graphique autour d'éléments visuels
						comme les icônes, les illustrations vectorielles, les animations,
						les couleurs pep's…
						<br />
						Ergonomiquement, le travail a été orienté sur la{' '}
						<strong>simplicité de prise en main du jeu</strong>. En effet,
						l'outil devait être attractif visuellement pour engager les
						collaborateurs à jouer, mais devait également être clair et simple
						au niveau des différentes options du jeu de simulation boursière.
					</p>

					<div className="caption">
						<img src={cic1} alt=""/>
						<i>
							Accueil du jeu où on retrouve les différentes manches pour accéder
							aux questions-réponses, activées au fur et à mesure des semaines,
							et proposant les différents types de profil client.
							<br />
							À droite de l'écran, un classement live toujours disponible pour
							challenger les équipes.
							<br />
							En bas de l'écran, un bandeau d'actualité mis à jour par le CIC.
						</i>
					</div>
					<div className="caption">
						<img src={cic2} alt=""/>
						<i>
							Dans un style « bande dessinée », le bureau du conseiller est
							reconstitué. C'est dans cet univers que le client virtuel est
							accueilli, le collaborateur répond ensuite à une série de
							questions diffusées sur son écran, en rapport avec le profil
							client: QCM, QCU, rébus, lettres dans le désordre, etc.…, afin de
							cumuler des points pourle jeu de simulation boursière
						</i>
					</div>
					<div className="caption">
						<img src={cic3} alt=""/>
						<i>
							Le collaborateur accède ensuite à un espace dédié au jeu de
							simulation boursière. Sur la « Place de la Bourse », il peut
							utiliser ses points convertis en euros pour investir dans les
							différents véhicules d'investissement, et gérer son portefeuille
							en achetant ou revendant des parts, en fonction du cours de la
							Bourse simulé dans l'outil.
						</i>
					</div>
				</ProjectContent>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/projet/fiches/cic-serious-game.js